import { combineReducers } from 'redux';
import modalsReducer from './modalsReducer';
import urlReducer from './urlReducer';
import courseReducer from './courseReducer';
import sideBarReducer from './sideBarReducer';
import themeReducer from './themeReducer';

const uiRootReducer = combineReducers({
	modals: modalsReducer.reducer,
	url: urlReducer.reducer,
	course: courseReducer.reducer,
	sideBar: sideBarReducer.reducer,
	theme: themeReducer.reducer,
});

export default uiRootReducer;
